<template>
  <div>
    <div class="pbr-box" style="height: calc(100vh - 65px);">
      <Header ref="pbrHeader" :title='title' :notice-list="noticeList"></Header>
      <!-- 没有强刷的数据暂时加上，如果有需要排除的页面，使用exclude或include进行过滤 -->
      <keep-alive>
        <router-view class="pbr-router"/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
// import './common/css/common.css'
import MD5 from 'crypto-js/md5'
import Vue from 'vue'
import './common/js/pbrAxios'
import './common/js/globalComponent'
import {sStorage} from './common/utils/storage'
import Header from './Header'

export default {
  name: 'Pbr',
  data () {
    return {
      title: this.$t('rootTitle'),
      noticeList: [],
      timer:null,
      themeArr: ['dark', 'white']
    }
  },
  components: {
    Header
  },
  methods: {
    changeTitle (title) {
      this.title = title || this.$t('rootTitle')
    },
    renderNotice (list) {
      this.noticeList = list || []
    },
    hideContainer (full=false){
      this.$store.commit('hideContainer',full)
      if (JSON.parse(full)){
        this.$refs.pbrHeader.isFull = true
        document.querySelector(".home_header").parentElement.style.height = 0
        document.querySelector(".home_header").parentElement.style.overflow = 'hidden'
        document.querySelector('#myapp .left_content').style.display = 'none'
        document.querySelector("#myapp .pbr-box").parentElement.classList.remove("col-md-11")
        document.querySelector("#myapp .pbr-box").parentElement.classList.remove("col-ms-11")
        document.querySelector("#myapp .pbr-box").parentElement.classList.add("col-md-12")
        document.querySelector("#myapp .pbr-box").parentElement.classList.add("col-sm-12")
        document.querySelector("#myapp .pbr-box").parentElement.style.minHeight = '100vh'
        document.querySelector(".pbr-box").style.height = '100vh'

        if (document.querySelector(".patch-home")){
          document.querySelector(".patch-home").style.height = '100vh !important'
        }
      }else{
        this.$refs.pbrHeader.isFull = false
        document.querySelector(".home_header").parentElement.style.height = ''
        document.querySelector(".home_header").parentElement.style.overflow = ''
        document.querySelector('#myapp .left_content').style.display = '' //#bd-docs-nav
        document.querySelector("#myapp .pbr-box").parentElement.classList.add("col-md-11")
        document.querySelector("#myapp .pbr-box").parentElement.classList.add("col-ms-11")
        document.querySelector("#myapp .pbr-box").parentElement.classList.remove("col-md-12")
        document.querySelector("#myapp .pbr-box").parentElement.classList.remove("col-ms-12")
        document.querySelector("#myapp .pbr-box").parentElement.style.minHeight = ''
        document.querySelector(".pbr-box").style.height = 'calc(100vh - 65px)'
        // if (document.querySelector(".patch-home")){
        //   document.querySelector(".patch-home").style.height = ''
        // }
      }
    },
    copyToPasteBoard(data){
      const el = document .createElement( 'textarea' );
      el.value = data;
      el.setAttribute( 'readonly' , '' );
      el.style.position = 'absolute' ;
      el.style.left = '-9999px' ;
      document .body.appendChild(el);
      el.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success(this.$t('message.copiedToTheClipboard'))
      }
      document.body.removeChild(el);
    },
    themeChange(type){
      sessionStorage.setItem('theme',type)
      this.$store.commit('theme',type)
      // this.$store.commit('brpaModule/theme',type)
      document.getElementById('theme').href = './static/css/theme/'+type+'.css'
    }
  },
  watch: {

  },
  provide () {
    return {
      renderNotice: this.renderNotice,
      hideContainer: this.hideContainer,
      copyToPasteBoard: this.copyToPasteBoard
    }
  },
  beforeCreate(){

  },
  created () {
    this.$on('renderNotice', this.renderNotice)
    sStorage.set('pbrIndexModule', { currentModule: '', sj: { params: {}, tags: [] }, xm: { params: {}, tags: [] }, fx: { params: {}, tags: [] } })
  },
  mounted () {
    /* this.$pbrAxios.post('/front/project/search').then((data) => {
        console.log(data)
      }) */

    try {
      const lang = localStorage.getItem('locale')
     lang === 'en' && window.PdLanguage.setLanguage({
        common: {
          _de: '_de',
          add: 'add',
          addSuccess: 'addSuccess',
          all: 'all',
          allOptions: 'allOptions',
          analyse: 'analyse',
          and: 'and',
          apply: 'apply',
          auto: 'auto',
          back: 'back',
          cancel: 'cancel',
          checkAll: 'checkAll',
          clear: 'clear',
          clearAll: 'clearAll',
          confirm: 'confirm',
          confirmDelete: 'confirmDelete',
          confirmDelete$1: 'confirmDelete$1',
          count: 'count',
          custom: 'custom',
          defaultValue: 'defaultValue',
          delete: 'delete',
          deleteConfirm: 'deleteConfirm',
          deleteSuccess: 'deleteSuccess',
          desc: 'desc',
          doNotMerge: 'doNotMerge',
          edit: 'edit',
          enlarge: 'enlarge',
          explore: 'explore',
          export: 'export',
          equal: 'equal',
          event: 'event',
          exist: 'exist',
          expandOrCollapse: 'expandOrCollapse',
          filter: 'filter',
          formControlLabel: {
            checkbox: 'checkbox',
            date: 'date',
            dateRange: 'dateRange',
            datetime: 'datetime',
            datetimeRange: 'datetimeRange',
            input: 'input',
            radio: 'radio',
            select: 'select',
            switch: 'switch',
            group: 'group'
          },
          fullscreen: 'fullscreen',
          fullscreenTitle: 'fullscreenTitle',
          greaterThan: 'greaterThan',
          greaterThanOrEqualTo: 'greaterThanOrEqualTo',
          gt: 'gt',
          gte: 'gte',
          hide: 'hide',
          href: 'href',
          image: 'image',
          imagePlaceholder: 'imagePlaceholder',
          is: 'is',
          inDataLoading: 'inDataLoading',
          inLoading: 'inLoading',
          isEqual: 'isEqual',
          isNot: 'isNot',
          keyword: 'keyword',
          latitude: 'latitude',
          longitude: 'longitude',
          lessThan: 'lessThan',
          lessThanOrEqualTo: 'lessThanOrEqualTo',
          lt: 'lt',
          lte: 'lte',
          max: 'max',
          merge: 'merge',
          min: 'min',
          more: 'more',
          must: 'must',
          name: 'name',
          neq: 'neq',
          nextPage: 'nextPage',
          no: 'no',
          notEqual: 'notEqual',
          notExist: 'notExist',
          object: 'object',
          optional: 'optional',
          options: 'options',
          off: 'off',
          on: 'on',
          or: 'or',
          other: 'other',
          play: 'play',
          prevPage: 'prevPage',
          preview: 'preview',
          range: 'range',
          rename: 'rename',
          required: 'required',
          run: 'run',
          section: 'section',
          selectAll: 'Select All',
          serialNumber: 'serialNumber',
          showOrHide: 'showOrHide',
          show: 'show',
          source: 'source',
          stat: 'stat',
          statistics: 'statistics',
          step: 'step',
          stop: 'stop',
          timeLabel: {
            date: 'date',
            hour: 'hour',
            minute: 'minute',
            month: 'month',
            quarter: 'quarter',
            second: 'second',
            year: 'year'
          },
          title: 'title',
          to: 'to',
          toolbar: 'toolbar',
          type: 'type',
          unknow: 'unknow',
          update: 'update',
          updateSuccess: 'updateSuccess',
          view: 'view',
          yes: 'yes',
          zoomIn: 'zoomIn',
          zoomOut: 'zoomOut'
        },
        other: {
          autocomplete: {
            keyword: 'Please enter key words...',
            noData: 'sorry,noData'
          },
          cluster: '聚簇',
          clusterStats: '聚簇统计',
          collapse: 'collapse',
          collapseTools: '收起工具栏',
          conceptVisualization: '概念可视化',
          expand: 'expand',
          expandTools: '展开工具栏',
          fieldName: '字段名',
          graphView: '图谱展示',
          horizontalView: '横向视图',
          input: '请输入',
          inputType: '输入类型',
          isDisabled: '是否禁用',
          isEditable: '是否可编辑',
          isDeletable: '是否可删除',
          isRequire: '是否必填',
          labelModel: 'Label模式',
          modelVisualization: '模型可视化',
          multiSelect: '多选',
          noAnswer: '没有找到结果',
          number: '数字类型',
          openOrClose: '收起/展开',
          pagination: {
            first: '首页',
            jumpTo: '跳转到',
            last: '末页',
            page: '页',
            prev: '上一页',
            prev$1Page: '往前翻$1页',
            next: '下一页',
            next$1Page: '往后翻$1页',
            total$1: '共计$1个'
          },
          placeholderModel: 'Placeholder模式',
          reason: '理由',
          relatedNodesCount: '相关实体个数',
          saveValue: '存储值',
          select: 'select',
          setFocus: '设为焦点',
          showModel: '显示模式',
          showName: '显示名称',
          showRelation: '展示对象属性',
          showValue: '显示值',
          studyOnly: '本页面仅供学习、参考使用<br/>如有侵权，请联系021-35073581',
          text: '文本类型',
          time: '时间',
          topNodes: '模块度最高的Top节点',
          verticalView: '纵向视图'
        },
        graph: {
          attribute: '属性',
          backward: 'backward',
          className: '类别',
          concept: '概念',
          privateAttribute: '私有属性',
          dataAttribute: '数值属性',
          dataType: '数据类型',
          dataTypeMap: {
            integer: '整数',
            float: '浮点数',
            datetime: '日期时间',
            date: '日期',
            time: '时间',
            varchar: '短文本型',
            computed: '计算属性',
            Map: 'Map型',
            text: '文本型',
            // image: '图片',
            // file: '文件',
            // media: '音、视频',
            href: '超链接'
          },
          dataUnit: '单位',
          define: '定义',
          domain: '定义域',
          direction: '指向',
          edgeDataAttribute: '边数值属性',
          edgeObjectAttribute: '边对象属性',
          endTime: '结束时间',
          entity: '实体',
          event: '事件',
          forward: 'forward',
          from: '起点',
          hypermymyAndHyponymy: '上下位',
          infobox: '知识卡片',
          instance: '实例',
          meaningTag: '消歧标识',
          name: '名称',
          notSingeType: '非单值型',
          objectAttribute: '对象属性',
          private: '私有',
          privateRelation: '私有关系',
          range: '值域',
          relation: '关系',
          singleType: '单值型',
          startTime: '开始时间',
          to: '终点',
          type: '类型',
          twoWay: 'twoWay',
          undirected: '无向',
          vague: '虚化',
          display: {
            circle: '圆形',
            diamond: '菱形',
            roundText: '圆角文字',
            roundRect: '圆角文字',
            rectangle: '方形',
            custom: '自定义'
          }
        },
        plugin: {
          resetLayout: {
            resetLayout: 'Reset layout'
          },
          attValueRule: {
            all: 'all',
            attributeFilter: 'attributeFilter',
            configIsNeed: 'configIsNeed',
            entityNoDataTip: 'entityNoDataTip',
            entityNoAttributeValue: 'entityNoAttributeValue',
            equalConditionCannotEmpty: 'equalConditionCannotEmpty',
            existConditionCannotEmpty: 'existConditionCannotEmpty',
            loadAttributeFailed: 'loadAttributeFailed',
            maxMustGreaterThenMin: 'maxMustGreaterThenMin',
            minMaxCannotEmpty: 'minMaxCannotEmpty',
            noCondition: 'noCondition',
            notEqualConditionCannotEmpty: 'notEqualConditionCannotEmpty',
            notExistConditionCannotEmpty: 'notExistConditionCannotEmpty',
            notSpecified: 'notSpecified',
            relationFilter: 'relationFilter',
            relationNoAttributeValue: 'relationNoAttributeValue',
            relationNoDataTip: 'relationNoDataTip',
            secondFilter: 'secondFilter',
            selectedRangeIsEmpty: 'selectedRangeIsEmpty',
            unknowType: 'unknownType'
          },
          changeLayout: {
            changeLayout: 'Change layout',
            force: 'Dynamic layout',
            horizontalLine: 'Horizontal layout',
            layout: 'layout',
            leftTree: 'Left tree layout',
            pack: 'Package layout',
            partition: 'Partition layout',
            radial: 'Radial layout',
            radialForce: 'Radial force layout',
            ring: 'Circular layout',
            reverseTree: 'Reverse tree layout',
            rightTree: 'Right tree layout',
            sankey: 'Sangji layout',
            static: 'Static layout',
            tree: 'Tree layout',
            treemap: 'Rectangle tree layout',
            verticalLine: 'Vertical layout'
          },
          page: {
            customPageSize: 'customPageSize',
            dataLoadingTryLater: 'dataLoadingTryLater',
            noMoreData: 'noMoreData',
            next: 'next',
            page: 'page',
            prev: 'prev',
            eachPage: 'eachPage',
            thisIsTheFirstPage: 'thisIsTheFirstPage'
          },
          prompt: {
            advancedPrompt: 'advancedPrompt',
            prompt: 'prompt',
            promptMulti: 'promptMulti',
            add: 'add',
            added: 'added',
            addRule: 'addRule',
            in: 'in',
            inputSearchKeyword: 'inputSearchKeyword~',
            keyword: 'keyword',
            registeredCapital: 'registeredCapital',
            resultIsNotFound: 'resultIsNotFound~',
            rule: 'rule',
            searchKeyword: 'searchKeyword',
            searchResult: 'searchResult',
            searchRule: 'searchRule',
            selectedAnalysisEntities: 'selectedAnalysisEntities'
          },
          history: {
            history: 'history'
          },
          filter: {
            addRule: 'addRule',
            allowAttrGroups: 'allowAttrGroups',
            allowAtts: 'Set analysis relationship',
            allowTypes: 'Set analysis subject',
            attAttFilters: 'attAttFilters',
            close: 'close',
            custom: {
              distance: 'distance'
            },
            direction: 'direction',
            distance: 'distance',
            distanceExpend: 'distanceExpend',
            doNotMerge: 'doNotMerge',
            explore: {
              distance: 'distance'
            },
            filter: 'filter',
            filterableAttributeOrRelationIsNotExist: 'filterableAttributeOrRelationIsNotExist',
            graph: {
              distance: 'distance'
            },
            highLevelSize: 'highLevelSize',
            hyponymyDistance: 'hyponymyDistance',
            level: 'level',
            merge: 'merge',
            path: {
              distance: 'distance'
            },
            relation: {
              distance: 'distance'
            },
            relationMerge: 'relationMerge',
            reliability: 'reliability',
            score: 'score',
            showAll: 'Show All'
          }
        }
      });
    }catch (e) {

    }

    let {full = false, theme} = this.$route.query
    this.hideContainer(full)
    if (!this.themeArr.includes(theme)) {
      theme = 'white'
    }
    this.themeChange(theme)
  },
  destroyed () {
    this.timer = null
  }
}
</script>
<style>
  .pbr-box .active{
    padding: 0;
    border: none;
  }
</style>
